import { render, staticRenderFns } from "./DetailsCmp.vue?vue&type=template&id=0654c38a&scoped=true"
import script from "./DetailsCmp.vue?vue&type=script&lang=js"
export * from "./DetailsCmp.vue?vue&type=script&lang=js"
import style0 from "./DetailsCmp.vue?vue&type=style&index=0&id=0654c38a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0654c38a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0654c38a')) {
      api.createRecord('0654c38a', component.options)
    } else {
      api.reload('0654c38a', component.options)
    }
    module.hot.accept("./DetailsCmp.vue?vue&type=template&id=0654c38a&scoped=true", function () {
      api.rerender('0654c38a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/postalCodeCorrection/components/DetailsCmp.vue"
export default component.exports